import React from 'react';
import classnames from 'classnames';

import Card from 'react-bootstrap/Card';
import Description from 'shared/product_tabs/tab_accessories/components/shared/Description';
import ProductImage from 'shared/product_tabs/tab_accessories/components/shared/ProductImage';
import Quantity from 'shared/product_tabs/tab_accessories/components/shared/Quantity';
import Title from 'shared/product_tabs/tab_accessories/components/shared/Title';
import UnitPrice from 'shared/product_tabs/tab_accessories/components/shared/UnitPrice';

const Accessory = ({ accessory, accessoryClassName, onChangeQuantity, onSelect }) => {
  const {
    images,
    index,
    name,
    product_url,
    quantity,
    selected,
    selected_variant,
    short_description,
    slug,
  } = accessory;

  const onChangeQty = (qty) => {
    onChangeQuantity(index, qty);
  };

  return (
    <Card className={classnames('accessory-item', accessoryClassName)}>
      <Card.Body>
        <Title
          id={`accessory-checkbox-select-${index}`}
          name={`accessory-checkbox-select-${index}`}
          title={name}
          checked={selected}
          product_url={product_url}
          onChange={() => onSelect(index)} />
        <Description
          productSlug={slug}
          description={short_description} />

        <div className="row">
          <div className="col-6 col-md-12">
            <Quantity
              quantity={quantity}
              onChangeQuantity={onChangeQty} />
            <UnitPrice
              variant={selected_variant} />
          </div>
          <div className="col-6 col-md-12">
            <ProductImage
              productName={name}
              productSlug={slug}
              product_url={product_url}
              images={images} />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default Accessory;
